/* unplugin-vue-components disabled */import i18n from '@/lang';
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/web.dom-collections.for-each.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import _objectSpread from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapMutations } from 'vuex';
import { apieventdetail, getEventDetailCtrlList } from '@/api';
import { orderStatusMapping, statusColorMapping, getEventFilterState } from '@/constant';
import pageInfo from './pageInfo/index';
import ViewBox from "vux/src/components/view-box/index.vue"; // this line is trasformed by vux-loader
import Tab from "vux/src/components/tab/tab.vue"; // this line is trasformed by vux-loader
import TabItem from "vux/src/components/tab/tab-item.vue"; // this line is trasformed by vux-loader
import Swiper from "vux/src/components/swiper/swiper.vue"; // this line is trasformed by vux-loader
import SwiperItem from "vux/src/components/swiper/swiper-item.vue"; // this line is trasformed by vux-loader
import Flow from "vux/src/components/flow/flow.vue"; // this line is trasformed by vux-loader
import FlowState from "vux/src/components/flow/flow-state.vue"; // this line is trasformed by vux-loader
import FlowLine from "vux/src/components/flow/flow-line.vue"; // this line is trasformed by vux-loader
import Tags from '@/components/Tags';
import OrderInfo from './OrderInfo';
import EventBottomOptions from './EventBottomOptions';
export default {
  components: {
    ViewBox: ViewBox,
    Tags: Tags,
    Tab: Tab,
    TabItem: TabItem,
    Swiper: Swiper,
    SwiperItem: SwiperItem,
    OrderMessage: function OrderMessage() {
      return import('./OrderMessage');
    },
    CustomerEvaluate: function CustomerEvaluate() {
      return import('./CustomerEvaluate');
    },
    OrderInfo: OrderInfo,
    DetailCtrlList: function DetailCtrlList() {
      return import('./DetailCtrlList');
    },
    EventBottomOptions: EventBottomOptions,
    Flow: Flow,
    FlowState: FlowState,
    FlowLine: FlowLine,
    pageInfo: pageInfo
  },
  props: {
    eventId: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      orderService: {},
      orderStatusMapping: orderStatusMapping,
      statusColorMapping: statusColorMapping,
      orderInfo: {},
      template: {},
      // 模板信息
      abnormalOrder: {},
      eventProduct: {},
      orderExtFields: [],
      remarkPicList: [],
      orderServiceNodes: [],
      serviceTreeMap: {},
      evaluatePicList: [],
      moneyItemEditRoles: [],
      examineUsers: [],
      detailCtrlList: [],
      is_view_settlement: 0,
      is_view_receipt: 0,
      tabsIndex: 0,
      tagLineShow: false,
      // 客户id
      customerId: 0,
      custtomShow: false,
      // 工单标签
      taglist: [],
      address: '',
      reloadflag: false,
      isEditCoordination: false,
      // 是否开启编辑协同人
      sourceIcon: {
        2: 'icon_h532_32@3x',
        3: 'icon_wechat32_32@3x',
        7: 'icon_ding32_32@3x'
      },
      isShowOrderMessage: 0,
      isServiceAmount: false,
      // nwe
      eventMap: {},
      eventTmpl: {},
      otherFiledValueList: [],
      getEventFilterState: getEventFilterState,
      serviceList: []
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('globalStore', ['user'])), {}, {
    orderState: function orderState() {
      return this.orderStatusMapping.get("".concat(this.orderInfo.state, "_").concat(this.orderInfo.evaluate_state));
    },
    eventState: function eventState() {
      return this.getEventFilterState(this.eventMap);
    },
    isOrderMessage: function isOrderMessage() {
      return true;
    },
    isCustomerEvaluate: function isCustomerEvaluate() {
      return this.eventState.value === 3;
    },
    tabs: function tabs() {
      var tabs = [i18n.tc("525")];
      if (this.isOrderMessage) tabs.push(i18n.tc("526"));
      if (this.isCustomerEvaluate) tabs.push(i18n.tc("527"));
      this.detailCtrlList.forEach(function (item) {
        tabs.push(item.serviceNodeTmplName);
      });
      return tabs;
    },
    stateList: function stateList() {
      /* eslint-disable camelcase */
      var eventMap = this.eventMap;
      var dispatch_state = eventMap.dispatch_state;
      var process_state = eventMap.process_state;
      var list = [{
        name: i18n.tc("53"),
        value: 1,
        stateDone: dispatch_state === 1,
        lineDone: dispatch_state === 1
      }, {
        name: i18n.tc("54"),
        value: 2,
        stateDone: process_state > 0,
        lineDone: process_state > 0
      }, {
        name: i18n.tc("55"),
        value: 3,
        stateDone: process_state > 1,
        lineDone: process_state > 1
      }, {
        name: i18n.tc("56"),
        value: 4,
        stateDone: process_state === 2,
        lineLimit: true
      }];
      return list;
    }
  }),
  watch: {},
  methods: _objectSpread(_objectSpread({}, mapMutations('globalStore', ['_pageReload'])), {}, {
    onSuccessBottomBtn: function onSuccessBottomBtn(key) {
      var _this = this;
      var action = {
        message: function message() {
          return _this.$refs.orderMessage.reload(true);
        },
        evaluate: function evaluate() {
          return _this.$refs.customerEvaluate.reload();
        }
      };
      this.reload();
      this._pageReload({
        order: true
      });
      action[key] && action[key]();
    },
    reload: function reload(flag) {
      var _this2 = this;
      apieventdetail({
        eventId: this.eventId
      }).then(function (res1) {
        if (res1.success) {
          _this2.eventMap = res1.data.eventMap;
          _this2.eventTmpl = res1.data.eventTmpl;
          _this2.otherFiledValueList = res1.data.otherFiledValueList;
          _this2.serviceList = res1.data.serviceList || [];
          _this2.eventProduct = res1.data.eventProduct;
        }
      });
    },
    getOrderDetailCtrlList: function getOrderDetailCtrlList() {
      var _this3 = this;
      getEventDetailCtrlList({
        objId: this.eventId,
        ctrlType: 3
      }).then(function (res) {
        if (res.success) _this3.detailCtrlList = res.data || [];
      });
    }
  }),
  created: function created() {
    this.getOrderDetailCtrlList();
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    apieventdetail({
      eventId: to.params.eventId
    }).then(function (res1) {
      next(function (vm) {
        if (res1.success) {
          vm.eventMap = res1.data.eventMap;
          vm.eventTmpl = res1.data.eventTmpl;
          vm.otherFiledValueList = res1.data.otherFiledValueList;
          vm.serviceList = res1.data.serviceList || [];
          vm.eventProduct = res1.data.eventProduct;
        }
      });
    });
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    next();
  }
};